export let tecnologies = {
    front: ["html", "css", "bootstrap", "react", "redux", "javascript"],
    back: ["nodejs", "express", "sequelize"],
    db: ["postgresql", "sqlite"],
}


export let projects = [
    {
        name: "counter",
        url: "https://counter-flame-three.vercel.app/",
    },
    {
        name: "dogs",
        url: "https://dogs-project-tau.vercel.app/",
    },
    {
        name: "chat-io",
        url: "https://chat-fullstackio.herokuapp.com/",
    }
];